// Single source of truth for feature flag names — values must match the backend's exact keys.
// Most keys use dot-notation (e.g. 'claim.file-upload'), but this isn't a strict convention —
// some flags are namespaced with a colon instead (e.g. 'warranty-dates:enable-in-application').
export enum FeatureFlagKey {
    CLAIM_FILE_UPLOAD = 'claim.file-upload',
    QUOTE_FILE_UPLOAD = 'quote.file-upload',
    ENROLLMENT_FILE_UPLOAD = 'enrollment.file-upload',
    APPLY_WARRANTY_DATES = 'warranty-dates:enable-in-application',
    QUOTE_PLAN_TERM_HOURS = 'quote.multi-term',
}
